import { render, staticRenderFns } from "./ScoreBreakdownPopup.vue?vue&type=template&id=42875b70&scoped=true&"
import script from "./ScoreBreakdownPopup.vue?vue&type=script&lang=js&"
export * from "./ScoreBreakdownPopup.vue?vue&type=script&lang=js&"
import style0 from "./ScoreBreakdownPopup.vue?vue&type=style&index=0&id=42875b70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42875b70",
  null
  
)

export default component.exports